import { render, staticRenderFns } from "./BillList.vue?vue&type=template&id=4784b064&scoped=true&lang=pug&"
import script from "./BillList.vue?vue&type=script&lang=ts&"
export * from "./BillList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4784b064",
  null
  
)

export default component.exports